module.exports = __webpack_public_path__ + "static/img/shuzhiCompany.22f17d10.png";